import script from "./ChatInput.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatInput.vue?vue&type=script&setup=true&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=234e438b&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234e438b"]])

export default __exports__